import React, { useState } from 'react';
import { Search, ChevronLeft, ChevronRight } from 'lucide-react';
import { format, startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachDayOfInterval, isSameMonth, isSameDay, addMonths, subMonths } from 'date-fns';

const Sidebar = () => {
    const [currentDate, setCurrentDate] = useState(new Date(2022, 0, 1)); // January 2022 as per mockup
    const [selectedDate, setSelectedDate] = useState(new Date(2022, 0, 1)); // Jan 1st is selected

    const nextMonth = () => setCurrentDate(addMonths(currentDate, 1));
    const prevMonth = () => setCurrentDate(subMonths(currentDate, 1));
    const onDateClick = (day) => setSelectedDate(day);

    const monthStart = startOfMonth(currentDate);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart, { weekStarts: 1 }); // Monday start
    const endDate = endOfWeek(monthEnd, { weekStarts: 1 });

    const dateFormat = "d";
    const days = eachDayOfInterval({ start: startDate, end: endDate });

    const weekDays = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

    return (
        <div className="dashboard-sidebar">
            <div className="search-bar">
                <Search className="search-icon" size={18} />
                <input type="text" placeholder="Search Event.." />
            </div>

            <div className="mini-calendar">
                <div className="mini-calendar-header">
                    <button className="mini-calendar-nav" onClick={prevMonth}>
                        <ChevronLeft size={20} />
                    </button>
                    <span>{format(currentDate, "MMMM yyyy")}</span>
                    <button className="mini-calendar-nav" onClick={nextMonth}>
                        <ChevronRight size={20} />
                    </button>
                </div>
                
                <div className="mini-calendar-grid">
                    {weekDays.map(day => (
                        <div key={day} className="day-name">{day}</div>
                    ))}
                    
                    {days.map((day, idx) => {
                        const isCurrentMonth = isSameMonth(day, monthStart);
                        const isSelected = isSameDay(day, selectedDate);
                        
                        return (
                            <div 
                                key={idx} 
                                className={`day-cell ${!isCurrentMonth ? 'other-month' : ''} ${isSelected ? 'active' : ''}`}
                                onClick={() => onDateClick(day)}
                            >
                                <span>{format(day, dateFormat)}</span>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* In the design, the first mockup has a purple essential, second has a green one. I'll use the purple one from DayView */}
            <div className="weekly-essential">
                <h3>Weekly Essential</h3>
                <p>Weekly essentials help you stay prepared and productive — whether it's stocking up on groceries, scheduling important tasks, or dedicating time to rest and self-care.</p>
            </div>
        </div>
    );
};

export default Sidebar;
